import React from 'react'

// Sidebar-toggle glyph (rounded rectangle with a vertical bar on the left)
// to match the standard "show/hide sidebar" iconography used in modern apps.
const SidebarToggleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2.5"
      stroke="currentColor"
      strokeWidth="1.75"
    />
    <line
      x1="9.25"
      y1="5.5"
      x2="9.25"
      y2="18.5"
      stroke="currentColor"
      strokeWidth="1.75"
    />
  </svg>
)

export default SidebarToggleIcon
